// Hebrew form validation messages with custom tooltip
document.addEventListener('DOMContentLoaded', function() {
  // Hebrew validation messages
  const hebrewMessages = {
    valueMissing: 'אנא מלא שדה זה.',
    typeMismatch: {
      email: 'אנא הזן כתובת אימייל תקינה.',
      tel: 'אנא הזן מספר טלפון תקין.',
      url: 'אנא הזן כתובת URL תקינה.'
    },
    patternMismatch: 'אנא התאם לפורמט הנדרש.',
    tooLong: 'הטקסט ארוך מדי.',
    tooShort: 'הטקסט קצר מדי.',
    rangeOverflow: 'הערך גדול מדי.',
    rangeUnderflow: 'הערך קטן מדי.',
    stepMismatch: 'הערך אינו תקין.'
  };

  // Function to get validation message
  function getValidationMessage(input) {
    const validity = input.validity;

    if (validity.valueMissing) {
      return hebrewMessages.valueMissing;
    } else if (validity.typeMismatch) {
      const inputType = input.type;
      return hebrewMessages.typeMismatch[inputType] || hebrewMessages.typeMismatch.email;
    } else if (validity.patternMismatch) {
      return hebrewMessages.patternMismatch;
    } else if (validity.tooLong) {
      return hebrewMessages.tooLong;
    } else if (validity.tooShort) {
      return hebrewMessages.tooShort;
    } else if (validity.rangeOverflow) {
      return hebrewMessages.rangeOverflow;
    } else if (validity.rangeUnderflow) {
      return hebrewMessages.rangeUnderflow;
    } else if (validity.stepMismatch) {
      return hebrewMessages.stepMismatch;
    }
    return '';
  }

  // Function to create custom tooltip
  function createCustomTooltip(input, message) {
    // Remove existing tooltip
    const existingTooltip = input.parentElement.querySelector('.custom-validation-message');
    if (existingTooltip) {
      existingTooltip.remove();
    }

    // Create new tooltip
    const tooltip = document.createElement('div');
    tooltip.className = 'custom-validation-message';
    tooltip.textContent = message;
    tooltip.style.display = 'block';

    // Insert tooltip after the input
    input.parentElement.appendChild(tooltip);

    // Auto hide after 5 seconds
    setTimeout(() => {
      if (tooltip.parentElement) {
        tooltip.remove();
      }
    }, 5000);

    return tooltip;
  }

  // Function to remove custom tooltip
  function removeCustomTooltip(input) {
    const tooltip = input.parentElement.querySelector('.custom-validation-message');
    if (tooltip) {
      tooltip.remove();
    }
  }

  // Function to set custom validation message
  function setCustomMessage(input) {
    const message = getValidationMessage(input);
    input.setCustomValidity(message);

    // Create custom tooltip for better appearance
    if (message && input.closest('.hdt-contact-form')) {
      createCustomTooltip(input, message);
    }
  }

  // Function to apply validation to an input element
  function applyValidationToInput(input) {
    // Set custom message on invalid event
    input.addEventListener('invalid', function(e) {
      setCustomMessage(this);

      // Prevent default browser tooltip for contact forms
      if (this.closest('.hdt-contact-form')) {
        e.preventDefault();
      }
    });

    // Clear custom message when input becomes valid
    input.addEventListener('input', function() {
      if (this.validity.valid) {
        this.setCustomValidity('');
        removeCustomTooltip(this);
      } else {
        const message = getValidationMessage(this);
        this.setCustomValidity(message);
      }
    });

    // Handle focus events
    input.addEventListener('focus', function() {
      removeCustomTooltip(this);
    });

    // Also handle blur event
    input.addEventListener('blur', function() {
      if (!this.validity.valid) {
        setCustomMessage(this);
      }
    });
  }

  // Apply to all form inputs with validation
  const inputs = document.querySelectorAll('input[required], textarea[required], select[required]');

  inputs.forEach(function(input) {
    applyValidationToInput(input);
  });

  // MutationObserver to handle dynamically added elements
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is an input with required attribute
          if (node.matches && node.matches('input[required], textarea[required], select[required]')) {
            applyValidationToInput(node);
          }

          // Check for required inputs within the added node
          const requiredInputs = node.querySelectorAll && node.querySelectorAll('input[required], textarea[required], select[required]');
          if (requiredInputs) {
            requiredInputs.forEach(function(input) {
              applyValidationToInput(input);
            });
          }
        }
      });
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Special handling for cart dropdown checkbox - periodically check for it
  function checkAndApplyCartCheckboxValidation() {
    const cartCheckbox = document.querySelector('.cart-consent-checkbox[required]');
    if (cartCheckbox && !cartCheckbox.hasAttribute('data-hebrew-validation-applied')) {
      applyValidationToInput(cartCheckbox);
      cartCheckbox.setAttribute('data-hebrew-validation-applied', 'true');
    }
  }

  // Check for cart checkbox periodically (helps with AJAX-generated content)
  setInterval(checkAndApplyCartCheckboxValidation, 1000);

  // Handle form submission to show custom tooltips
  document.addEventListener('submit', function(e) {
    const form = e.target;
    const invalidInputs = form.querySelectorAll(':invalid');

    if (invalidInputs.length > 0 && form.closest('.hdt-contact-form')) {
      e.preventDefault();

      // Show custom tooltips for all invalid inputs
      invalidInputs.forEach(function(input) {
        const message = getValidationMessage(input);
        if (message) {
          createCustomTooltip(input, message);
          input.setCustomValidity(message);
        }
      });

      // Focus first invalid input
      invalidInputs[0].focus();
    }
  });
});


document.querySelectorAll('[data-newsletter-btn]').forEach(button => {
  // Find parent form
  const form = button.closest('form');
  if (!form) return;

  // Find all checkboxes in the form
  const checkboxes = form.querySelectorAll('input[type="checkbox"]');

  // Function to check all checkboxes
  const checkAllChecked = () => {
    const allChecked = Array.from(checkboxes).every(chk => chk.checked);
    button.style.opacity = allChecked ? "1" : "0.5"; // Enable if all checked
  };

  // Listen for changes on each checkbox
  checkboxes.forEach(chk => {
    chk.addEventListener('change', checkAllChecked);
  });

  // Run on page load in case some checkboxes are pre-checked
  checkAllChecked();
});